import React, { useState, CSSProperties } from 'react';
import ConfirmDeleteAccount from '../settings/ConfirmDeleteAccount';

const DeleteAccount: React.FC = () => {
  const [isConfirmDeleteAccount, setConfirmDeleteAccount] = useState(false);
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);

  const closeDelete = () => setConfirmDeleteAccount(false);

  // Inline styles
  const baseBtn: CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 34,
    padding: '0 22px',
    borderRadius: 999,
    border: '0',
    background: '#ef4444',          // red
    color: '#fff',
    fontWeight: 600,
    fontSize: 13,
    cursor: 'pointer',
    userSelect: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,.08)',
    transition: 'transform .08s ease, box-shadow .12s ease, opacity .2s ease',
  };
  const hoverBtn: CSSProperties = {
    transform: 'translateY(-1px)',
    boxShadow: '0 6px 14px rgba(239,68,68,.28)',
  };
  const activeBtn: CSSProperties = {
    transform: 'translateY(0)',
    boxShadow: '0 2px 6px rgba(0,0,0,.16)',
    opacity: 0.95,
  };

  const buttonStyle: CSSProperties = {
    ...baseBtn,
    ...(hover ? hoverBtn : {}),
    ...(active ? activeBtn : {}),
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <p style={{  margin: '0px 0px 8px 0',fontSize:"18px", color: '#393939'}}>Delete Account</p>
        <p style={{ margin: '0',fontSize:"18px", color: '#393939' }}>
          Your profile and all data will be permanently deleted.
        </p>
      </div>

      <button
        style={buttonStyle}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => { setHover(false); setActive(false); }}
        onMouseDown={() => setActive(true)}
        onMouseUp={() => setActive(false)}
        onClick={() => setConfirmDeleteAccount(true)}
      >
        Delete Account
      </button>

      {isConfirmDeleteAccount ? (
        <ConfirmDeleteAccount cancelDelete={closeDelete} />
      ) : null}
    </div>
  );
};

export default DeleteAccount;
